export enum MfaCommand {
    verify = 'verify',
    continue = 'continue',
    cancel = 'cancel',
    reset = 'reset',
}
